import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const UTMTracker: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);

    const utmParams = {
      utm_source: params.get("utm_source"),
      utm_medium: params.get("utm_medium"),
      utm_campaign: params.get("utm_campaign"),
      utm_term: params.get("utm_term"),
      utm_content: params.get("utm_content"),
    };

    const hasUtm = Object.values(utmParams).some((value) => Boolean(value));

    if (hasUtm) {
      localStorage.setItem("fat_utm", JSON.stringify(utmParams));
      localStorage.setItem("fat_landing_page", window.location.href);
    }
  }, [location.search]);

  return null;
};

export default UTMTracker;